import { FilterListBean, SspBean } from 'common/api/api'
import TypeEnum = FilterListBean.TypeEnum
import SspTypeEnum = SspBean.SspTypeEnum

export const filterListTypeValues = [
    {id: TypeEnum.APPID, name: 'App/Bundle ID'},
    {id: TypeEnum.DOMAIN, name: 'Domain'},
    {id: TypeEnum.USERIDIPUA, name: 'User ID (IP+UA hash)'},
    {id: TypeEnum.USERIDIFA, name: 'User ID (IDFA/AAID)'},
    {id: TypeEnum.IPV4, name: 'IP v4'},
    {id: TypeEnum.IPV6, name: 'IP v6'}
]

export const getFilterListTypeName = (id:TypeEnum) => {
    return filterListTypeValues.find(data => data.id === id)?.name
}

export const sspTypeValues = [
    {id: SspTypeEnum.OpenRTB, name: 'OpenRTB'},
    {id: SspTypeEnum.CommonXML, name: 'CommonXML'},
    {id: SspTypeEnum.Bidswitch, name: 'Bidswitch'},
    {id: SspTypeEnum.Site, name: 'Site'},
]

export const dspAuctionTypeValues = [
    {id: SspBean.AuctionModeEnum.AuctionTypeFromRequest, name: 'Auction type from request'},
    {id: SspBean.AuctionModeEnum.FirstPrice, name: 'First price'},
    {id: SspBean.AuctionModeEnum.SecondPrice, name: 'Second price'},
]

export const ownedByValues = [
    // {id: 'SuperAdmin', name: 'System'},
    {id: 'Admin', name: 'Agency'},
    {id: 'Advertiser', name: 'Advertiser'},
]
